export type ThrottledCallback<A> = {
  cancel(): void;
  (arg1: A): void;
};
export const rafThrottle = <A>(callback: (arg1: A) => unknown): ThrottledCallback<A> => {
  // @ts-expect-error [EN-10263] - TS7034 - Variable 'requestId' implicitly has type 'any' in some locations where its type cannot be determined.
  let requestId = null;

  // @ts-expect-error [EN-10263] - TS7034 - Variable 'lastArgs' implicitly has type 'any' in some locations where its type cannot be determined.
  let lastArgs;

  const later = (context: Record<any, any>) => () => {
    requestId = null;
    // @ts-expect-error [EN-10263] - TS7005 - Variable 'lastArgs' implicitly has an 'any' type.
    callback.apply(context, lastArgs);
  };

  const throttled = function (this: Record<any, any>, ...args: [A]) {
    lastArgs = args;
    // @ts-expect-error [EN-10263] - TS7005 - Variable 'requestId' implicitly has an 'any' type.
    if (requestId === null) {
      requestId = requestAnimationFrame(later(this));
    }
  };

  throttled.cancel = () => {
    // @ts-expect-error [EN-10263] - TS7005 - Variable 'requestId' implicitly has an 'any' type.
    if (requestId == null) return;
    // @ts-expect-error [EN-10263] - TS7005 - Variable 'requestId' implicitly has an 'any' type.
    cancelAnimationFrame(requestId);
    requestId = null;
  };

  return throttled;
};
